import { candleParser } from "../candleParser";
/**
 * example:
 * {
	"messageType": "alertNotification",
	"notificationId": 1645474350675,
	"notificationDetails": {"updateType":"SETUP_FILTERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"direction":"ABOVE","candleBarrier":"HIGH","candleDuration":3,"timeUnit":"MINUTES","candle":{"high":100.2,"low":100.2,"open":100.2,"close":100.2,"candleSymbol":"XTz","candleStartTimeStamp":1641110640000,"duration":"1min"}},"triggerPrice":0.0,"tradeDirection":null,"tacticName":"PRICE_INTERSECTS_FIRST_CANDLE","symbol":"XYZ"},
	"date": "2022-02-21T15:12:31.252-0500",
	"timestamp": "1645474351254"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candleDuration
 * 2) timeUnit
 * 3) candle (object with fields: high,low,open,close,candleSymbol,duration,candleStartTimeStamp)
 * 4) direction (either ABOVE/BELOW. is the filter saying only allow trades above the candle high)
 * 5) candleBarrier (HIGH/LOW is the filter saying only allow trades below the canlde low)
 * 
 * the fields direction and candleBarrier are used together to interpret how the user wants to filter relative 
 * to the candle
 */
export function priceIntersectsFirstCandleParser(pluginTemplate) {
    const parsedObject = {
        direction: null,
        candleBarrier: null,
        candleDuration: null,
        timeUnit: null,
        candle: null,
    }
    if(pluginTemplate) {
        parsedObject.direction=pluginTemplate.direction;
        parsedObject.candleBarrier=pluginTemplate.candleBarrier;
        parsedObject.candleDuration=pluginTemplate.candleDuration;
        parsedObject.timeUnit=pluginTemplate.timeUnit;
        const candle = candleParser(pluginTemplate.candle);
        if(candle) {
            parsedObject.candle=candle;
        }
    }
    return parsedObject;
}